import * as React from "react";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useQrCodeScanner } from "../../context/app-context/code-scanner-context/code-scanner-context";
import { useMobileLogin } from "./use-mobile-login";
import { useBeep } from "../../hook/use-beep";
import { Sound } from "../../hook/use-sound";
import { Prompt } from "../feedback-screen/prompt/prompt";
import { PromptBanner } from "../feedback-screen/prompt/prompt-banner";
import { t } from "i18next";

interface IQRLoginScannerProps {
    onSuccess: (userName: string) => void;
}

export const QRLoginScanner = (props: IQRLoginScannerProps) => {
    const [scannedQrCode, setScannedQrCode] = useState<string | undefined>();

    useQrCodeScanner(code => setScannedQrCode(code));
    const { isSuccess, userName, errorMessage, clearErrorMessage } = useMobileLogin(scannedQrCode);

    useBeep(errorMessage, Sound.Error);
    useBeep(isSuccess, Sound.Success);
    const handleClearErrorMessage = useCallback(() => {
        setScannedQrCode(undefined);
        clearErrorMessage();
    }, []);

    useEffect(() => {
        if (isSuccess && userName) {
            props.onSuccess(userName);
        }
    }, [isSuccess, userName]);

    return <Fragment>
        <Prompt>
            {errorMessage &&
                <PromptBanner className={"prompt-text text--error"} onHide={handleClearErrorMessage}>
                    {errorMessage}
                </PromptBanner>}
            {t("login.qr.prompt")}
        </Prompt>
    </Fragment>;
};
